module.exports = __webpack_public_path__ + "static/media/pin.ec1a918c.svg";